export default __webpack_public_path__ + "static/media/step_B_EN.39ca50d5.png";